import Vue from 'vue'
import { Pagination,Message } from 'element-ui';
import App from './App.vue'
import VueRouter from 'vue-router'
import VideoPlayer from 'vue-video-player'
import VueI18n from 'vue-i18n'
import routes from './common/routes'

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(Pagination)
Vue.use(VideoPlayer)
Vue.prototype.$message = Message

const i18n = new VueI18n({
  locale: 'zh-CN',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./common/lang/zh'),   // 中文语言包
    'en-US': require('./common/lang/en')    // 英文语言包
  }
})

const routerConfig = new VueRouter({
  history: 'hash',
  routes: routes.pages
})

routerConfig.beforeEach((to, from, next) => {
  if (to.path === '/') {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next('/index')
  } else {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
  }

})

routerConfig.afterEach((to,from,next) => {
  $('#app').css({
    "height": "auto"
  })
});

new Vue({
  el: '#app',
  i18n,
  router: routerConfig,
  render: h => h(App)
})
